<template>
  <div>
    <div class="over-lay" @click="closePopup()"></div>
    <div class="popup">
      <span class="close-hldr" @click="closePopup()">
        <i class="material-icons">close</i>
      </span>
      <img class="salesgear-icon" src="@/assets/images/salesgearFullLogo.png" />
      <div class="salesgear-content">
        Add prospects to your workflow to automate your followups
      </div>
      <span class="salesgear-content sub-para">
        Once connected, you can automate all your prospect reach-outs as soon as
        your find their email address
      </span>
      <div class="btn-section d-flex">
        <V-Button
          :className="'connectBtn'"
          :text="'Connect'"
          :callback="goToConnect"
        ></V-Button>
      </div>
    </div>
  </div>
</template>

<script>
import button from '@/components/Button'
import { BASE_URL_NEW } from '@/assets/util/constants/constants.js'

export default {
  data: function() {
    return {
      showPopup: false
    }
  },
  components: {
    'V-Button': button
  },
  methods: {
    closePopup() {
      this.$emit('clickedOutside', true)
    },
    goToConnect() {
      window.open(`${BASE_URL_NEW}/integrations`, '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.over-lay {
  background: rgb(0, 0, 0, 0.85);
  position: fixed;
  height: 100%;
  top: 0px;
  width: 100%;
  left: 0;
  z-index: 3;
}
.popup {
  position: fixed;
  width: 85%;
  padding-top: 70px;
  padding-bottom: 30px;
  color: #474542;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  will-change: transform;
  border-radius: 6px;
  background-color: $white;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: initial;
  cursor: default;
  .close-hldr {
    position: absolute;
    right: 6px;
    top: 8px;
    display: flex;
    i {
      font-size: 15px;
      cursor: pointer;
      color: #787878;
    }
  }
  .salesgear-icon {
    position: absolute;
    width: 185px;
    height: auto !important;
    top: 18px;
    -webkit-animation: MoveUpDown 2s infinite alternate;
    animation: MoveUpDown 2s infinite alternate;
  }
  .salesgear-content {
    text-align: center;
    padding: 8px 20px;
    font-size: 14px;
  }
  .sub-para {
    font-size: 12px;
    background-color: #f7f7f7;
    margin-top: 10px;
    margin-bottom: 20px;
    color: $text-dark;
  }
  .btn-section::v-deep {
    flex-direction: column;
    button {
      width: 160px;
      padding: 10px 0px;
      margin: 5px;
      font-size: 12px;
      border: solid 1px #56a2f9;
      border-radius: 5px;
      letter-spacing: 0.3px;
      font-weight: 600;
      background-color: $white;
      &.btn-blue {
        transform: translateZ(0);
        background-color: $primary-color;
        box-shadow: 0 0 1px transparent;
        backface-visibility: hidden;
        color: $white;
        animation: tidleShake 5s linear infinite running;
        -webkit-animation: tidleShake 5s linear infinite running;
      }
      &.connectBtn {
        color: $primary-color;
      }
    }
  }
}
</style>
